import React from 'react';

import { featureFlags } from '@modules/featureFlags/utils/featureFlags';

import Banner from './Banner';

function BannerContainer() {
  const isEnabled = featureFlags.getFlag('SBL_3233_DYNAMIC_BANNER');

  if (!isEnabled) {
    return null;
  }

  return <Banner />;
}

export default BannerContainer;
